smartsearch.smartsearch(class="{ props.mobile ? 'sp' : 'pc' } { props.type } { props.type === 'in_modal' ? 'hidden' : '' }")
  template(if="{props.type === 'in_shop'}")
    form(action="/shops/{props.shopId}" accept-charset="UTF-8" method="get")
      input(type="hidden" name="cid" value="{state.categoryQuery}" if="{ !!state.categoryQuery }")
      input(type="hidden" name="gid" value="{state.referenceGroupQuery}" if="{ !!state.referenceGroupQuery }")
      input(type="hidden" name="rid" value="{state.referenceQuery}" if="{ !!state.referenceQuery }")
      input(type="hidden" name="sa" value="{state.keywordQuery}" if="{ !!state.keywordQuery }")
    .fields(class="{ props.type } { props.mobile ? 'sp' : 'pc' }")
      .category
        selectcategory-window(loader="{ props.categoryLoader }" mobile="{ props.mobile }" count="{ props.count }" observable="{ props.observable }" type="{ props.type }"
                              selected-categories="{ state.selectedCategories }" on-update="{onUpdateSelectedCategory}")
  template(if="{ props.type === 'in_sidebar' || props.type === 'in_modal' }")
    form#smart_search_form(action="/watches/" accept-charset="UTF-8" method="get")
      input(type="hidden" name="cid" value="{state.categoryQuery}" if="{ !!state.categoryQuery }")
      input(type="hidden" name="cl" value="{state.colorQuery}" if="{ !!state.colorQuery }")
      input(type="hidden" name="cw" value="{state.caseWidthQuery}" if="{ !!state.caseWidthQuery }")
      input(type="hidden" name="cwr" value="{state.caseWidthRangeQuery}" if="{ !!state.caseWidthRangeQuery }")
      input(type="hidden" name="fn" value="{state.functionQuery}" if="{ !!state.functionQuery }")
      input(type="hidden" name="gid" value="{state.referenceGroupQuery}" if="{ !!state.referenceGroupQuery }")
      input(type="hidden" name="gn" value="{state.genderQuery}" if="{ !!state.genderQuery }")
      input(type="hidden" name="mt" value="{state.materialQuery}" if="{ !!state.materialQuery }")
      input(type="hidden" name="mv" value="{state.movementQuery}" if="{ !!state.movementQuery }")
      input(type="hidden" name="pr" value="{state.priceRangeQuery}" if="{ !!state.priceRangeQuery }")
      input(type="hidden" name="rid" value="{state.referenceQuery}" if="{ !!state.referenceQuery }")
      input(type="hidden" name="sa" value="{state.keywordQuery}" if="{ !!state.keywordQuery }")
      input(type="hidden" name="st" value="{state.strapQuery}" if="{ !!state.strapQuery }")
      input(type="hidden" name="wp" value="{state.waterproofsQuery}" if="{ !!state.waterproofsQuery }")
      input(type="hidden" name="wpr" value="{state.waterproofsRangeQuery}" if="{ !!state.waterproofsRangeQuery }")
    .fields(class="{ props.type } { props.mobile ? 'sp' : 'pc' } { state.hasStock ? '' : 'nostock' }" if="{ props.type == 'in_sidebar' }")
      .category
        selectcategory-window(loader="{ props.categoryLoader }" mobile="{ props.mobile }" count="{ props.count }" observable="{ props.observable }" observable-key-suffix="{ props.type }"
                              selected-categories="{ state.selectedCategories }" on-update="{onUpdateSelectedCategory}")
      template(if="{ state.hasStock }")
        .field.keyword
          label(onclick="{ toggleField.bind(this, 'keyword') }")
            | キーワード
            img(if!="{ props.mobile && !state.showFieldFlags['keyword'] }" src="{ orangePlus }" height="19")
            img(if!="{ props.mobile && state.showFieldFlags['keyword'] }" src="{ orangeMinus }" height="19")
          input(if="{ !props.mobile || state.showFieldFlags['keyword'] }" type="text" name="sa" value="{ state.keywordQuery }" onkeyup="{ onChangeKeyword }" onkeypress="{ onPressKey }" placeholder="キーワードを入力")
        .field.price
          label(onclick="{ toggleField.bind(this, 'price') }")
            | 価格帯
            img(if!="{ props.mobile && !state.showFieldFlags['price'] }" src="{ orangePlus }" height="19")
            img(if!="{ props.mobile && state.showFieldFlags['price'] }" src="{ orangeMinus }" height="19")
          price-checkboxes(if="{ !props.mobile || state.showFieldFlags['price'] }" type="{ props.type}" mobile="{ props.mobile }" formdata="{ state.formData }" shouldnofollow="{ state.shouldNoFollow }" on-update="{onUpdatePriceRange}" priceranges="{ props.priceranges }" use-link="{ false }")
        .field.material
          label(onclick="{ toggleField.bind(this, 'material') }")
            | 素材
            img(if!="{ props.mobile && !state.showFieldFlags['material'] }" src="{ orangePlus }" height="19")
            img(if!="{ props.mobile && state.showFieldFlags['material'] }" src="{ orangeMinus }" height="19")
          material-checkboxes(if="{ !props.mobile || state.showFieldFlags['material'] }" type="{ props.type}" mobile="{ props.mobile }" formdata="{ state.formData }" shouldnofollow="{ shouldNoFollow }" on-update="{onUpdateMaterial}")
        .field.strap
          label(onclick="{ toggleField.bind(this, 'strap') }")
            | ストラップタイプ
            img(if!="{ props.mobile && !state.showFieldFlags['strap'] }" src="{ orangePlus }" height="19")
            img(if!="{ props.mobile && state.showFieldFlags['strap'] }" src="{ orangeMinus }" height="19")
          strap-checkboxes(if="{ !props.mobile || state.showFieldFlags['strap'] }" type="{ props.type }" mobile="{ props.mobile }" formdata="{ state.formData }" shouldnofollow="{ shouldNoFollow }" on-update="{onUpdateStrap}")
        .field.color
          label(onclick="{ toggleField.bind(this, 'color') }")
            | 文字盤色
            img(if!="{ props.mobile && !state.showFieldFlags['color'] }" src="{ orangePlus }" height="19")
            img(if!="{ props.mobile && state.showFieldFlags['color'] }" src="{ orangeMinus }" height="19")
          color-checkboxes(if="{ !props.mobile || state.showFieldFlags['color'] }" type="{ props.type }" mobile="{ props.mobile }" formdata="{ state.formData }" shouldnofollow="{ shouldNoFollow }" on-update="{onUpdateColor}")
        .field.case-width
          label(onclick="{ toggleField.bind(this, 'case-width') }")
            | ケースサイズ
            img(if!="{ props.mobile && !state.showFieldFlags['case-width'] }" src="{ orangePlus }" height="19")
            img(if!="{ props.mobile && state.showFieldFlags['case-width'] }" src="{ orangeMinus }" height="19")
          casewidth-checkboxes(if="{ !props.mobile || state.showFieldFlags['case-width'] }" type="{ props.type }" mobile="{ props.mobile }" formdata="{ state.formData }" shouldnofollow="{ shouldNoFollow }" on-update="{onUpdateCaseWidth}" casewidthes="{ props.casewidthes }")
        .field.gender
          label(onclick="{ toggleField.bind(this, 'gender') }")
            | 性別
            img(if!="{ props.mobile && !state.showFieldFlags['gender'] }" src="{ orangePlus }" height="19")
            img(if!="{ props.mobile && state.showFieldFlags['gender'] }" src="{ orangeMinus }" height="19")
          gender-checkboxes(if="{ !props.mobile || state.showFieldFlags['gender'] }" type="{ props.type }" mobile="{ props.mobile }" formdata="{ state.formData }" shouldnofollow="{ shouldNoFollow }" on-update="{onUpdateGender}")
        .field.waterproofs
          label(onclick="{ toggleField.bind(this, 'waterproofs') }")
            | 防水
            img(if!="{ props.mobile && !state.showFieldFlags['waterproofs'] }" src="{ orangePlus }" height="19")
            img(if!="{ props.mobile && state.showFieldFlags['waterproofs'] }" src="{ orangeMinus }" height="19")
          waterproofs-checkboxes(if="{ !props.mobile || state.showFieldFlags['waterproofs'] }" type="{ props.type }" mobile="{ props.mobile }" formdata="{ state.formData }" shouldnofollow="{ shouldNoFollow }" on-update="{onUpdateWaterproofs}")
        .field.movement
          label(onclick="{ toggleField.bind(this, 'movement') }")
            | ムーブメント
            img(if!="{ props.mobile && !state.showFieldFlags['movement'] }" src="{ orangePlus }" height="19")
            img(if!="{ props.mobile && state.showFieldFlags['movement'] }" src="{ orangeMinus }" height="19")
          movement-checkboxes(if="{ !props.mobile || state.showFieldFlags['movement'] }" type="{ props.type }" mobile="{ props.mobile }" formdata="{ state.formData }" shouldnofollow="{ shouldNoFollow }" on-update="{onUpdateMovement}")
        .field.functions
          label(onclick="{ toggleField.bind(this, 'functions') }")
            | { props.mobile ? "ムーブメント拡張機能" : "腕時計の機構" }
            img(if!="{ props.mobile && !state.showFieldFlags['functions'] }" src="{ orangePlus }" height="19")
            img(if!="{ props.mobile && state.showFieldFlags['functions'] }" src="{ orangeMinus }" height="19")
          function-checkboxes(if="{ !props.mobile || state.showFieldFlags['functions'] }" type="{ props.type }" mobile="{ props.mobile }" formdata="{ state.formData }" shouldnofollow="{ shouldNoFollow }" on-update="{onUpdateFunctions}")

        .search-button-wrap
          search-counter(type="{ props.type }" prefix="該当" suffix="件" count="{ props.count }" observable="{ props.observable }")
          button.search-button(type="button" onclick="{ submitSearch }")
            img(src="{searchIconImage}" width="22" height="17")
    .fields(class="{ props.type }" if="{ props.type == 'in_modal' }")
      selectcategory-window(loader="{ props.categoryLoader }" mobile="{ props.mobile }" count="{ props.count }" observable="{ props.observable }" type="{ props.type }"
                        selected-categories="{ state.selectedCategories }" on-update="{onUpdateSelectedCategory}")
      .header
        .header-title 条件絞り込み
        button.close(type="button" onclick="{ didClickClose }")
          img.close-icon(src="{closeIcon}")
          | 閉じる
      .field-group.scrollable
        .field.price
          .label 価格帯
          price-checkboxes(type="{ props.type }" observable="{ observable }" mobile="{ props.mobile }" formdata="{ state.formData }" shouldnofollow="{ state.shouldNoFollow }" on-update="{onUpdatePriceRange}" priceranges="{ props.priceranges }" use-link="{ false }")
        .field.material
          .label ケース素材
          material-checkboxes(type="{ props.type }" observable="{ observable }" mobile="{ props.mobile }" formdata="{ state.formData }" shouldnofollow="{ state.shouldNoFollow }" on-update="{onUpdateMaterial}")
        .field.strap
          .label ストラップ
          strap-checkboxes(type="{ props.type }" observable="{ observable }" mobile="{ props.mobile }" formdata="{ state.formData }" shouldnofollow="{ state.shouldNoFollow }" on-update="{onUpdateStrap}")
        .field.color
          .label 文字盤色
          color-checkboxes(type="{ props.type }" observable="{ observable }" mobile="{ props.mobile }" formdata="{ state.formData }" shouldnofollow="{ state.shouldNoFollow }" on-update="{onUpdateColor}")
        .field.case-width
          .label ケースサイズ
          casewidth-checkboxes(type="{ props.type }" observable="{ observable }" mobile="{ props.mobile }" formdata="{ state.formData }" shouldnofollow="{ state.shouldNoFollow }" on-update="{onUpdateCaseWidth}" casewidthes="{ props.casewidthes }")
        .field.gender
          .label 性別
          gender-checkboxes(type="{ props.type }" observable="{ observable }" mobile="{ props.mobile }" formdata="{ state.formData }" shouldnofollow="{ state.shouldNoFollow }" on-update="{onUpdateGender}")
        .field.waterproofs
          .label 防水
          waterproofs-checkboxes(type="{ props.type }" observable="{ observable }" mobile="{ props.mobile }" formdata="{ state.formData }" shouldnofollow="{ state.shouldNoFollow }" on-update="{onUpdateWaterproofs}")
        .field.movement
          .label ムーブメント
          movement-checkboxes(type="{ props.type }" observable="{ observable }" mobile="{ props.mobile }" formdata="{ state.formData }" shouldnofollow="{ state.shouldNoFollow }" on-update="{onUpdateMovement}")
        .field.functions
          .label 腕時計の機構
          function-checkboxes(type="{ props.type }" observable="{ observable }" mobile="{ props.mobile }" formdata="{ state.formData }" shouldnofollow="{ state.shouldNoFollow }" on-update="{onUpdateFunctions}")
      button.search(type="button" onclick="{ submitSearch }")
        search-counter(type="{ props.type }" prefix="該当" suffix="件" count="{ props.count }" observable="{ props.observable }")
        | 探す

  style(type="scss").
    .fields.in_sidebar {
      position: relative;
      padding-bottom: 50px;
      margin-top: 15px;
      .category {
        border: 3px solid #e8e8e8;
        border-left: none;
        border-right: none;
        padding: 0;
        margin-bottom: 11px;
      }
      .field {
        margin-bottom: 10px;
        label {
          font-size: 12px;
          font-weight: bold;
          color: #015205;
        }
        &.price { margin-bottom: 22px; }
        &.keyword {
          input {
            margin-top: 6px;
            border: 3px solid #e8e8e8;
            width: 100%;
            padding: 4px 4px 2px;
            font-weight: bold;
            font-size: 12px;
          }
        }
      }
      .search-button-wrap {
        position: absolute;
        top: 1000px;
        width: 196px;
        background: #d4a635;
        color: white;
        padding: 8px;
        display: flex;
        justify-content: space-between;
        .search-button {
          border: 0;
          padding: 8px 11px 6px;
          background: white;
          border-radius: 10px;
          &:hover {
            background: #5f3d3d;
          }
        }
        .loading-wrap {
          width: 135px;
          height: 35px;
          overflow: hidden;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        &:before {
          content: "";
          position: absolute;
          top: -24px;
          left: 50%;
          margin-left: -15px;
          border: 15px solid transparent;
          border-bottom-color: #d4a635;
          transform: scaleY(0.6);
        }
      }
      &.sp {
        padding: 0 11px 100px;
        &.nostock {
          padding-bottom: 0;
        }
        .category {
          border: none;
          padding-bottom: 0;
          margin-bottom: 0;
          label {
            font-size: 15px;
            color: #015205;
            font-weight: bold;
            margin-bottom: 12px;
            display: block;
          }
        }
        selectcategory-window {
          border: 2px solid #e8e8e8;
          border-left: none;
          border-right: none;
          display: block;
          padding: 18px 0 0;
          min-height: 62px;
        }
        .field {
          margin-bottom: 0;
          border-bottom: 2px solid #e8e8e8;
          padding-bottom: 16px;
          transition: height .3s;
          overflow: hidden;
          >label {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 15px;
            font-weight: bold;
            padding: 16px 13px 0;
            +* {
              margin-top: 16px;
            }
          }
          &.closed {
            height: 56px !important;
          }
          &.keyword {
            input {
              font-weight: normal;
              font-size: 15px;
              padding: 16px 16px 12px;
              -webkit-appearance: none;
              -moz-appearance: none;
              appearance: none;
              border-radius: none;
              margin-left: 13px;
              width: calc(100% - 26px);
            }
          }
        }
        .search-button-wrap {
          width: 100%;
          left: 0;
          z-index: 4;
          padding: 14px 8px;
          .search-button {
            margin-right: 4px;
          }
        }
      }
    }
    .fields.in_modal {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #fffef8;
      z-index: 5;
      padding-bottom: 17.97vw;
      * { font-family: 'Noto Sans JP', sans-serif; }
      .header {
        width: 100%;
        height: 21.09vw;
        border-bottom: 1px solid #bbbbbb;
        padding: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 5.625vw;

        &-title {
          color: #6c6c6c;
          font-size: 5.46875vw;
          line-height: 1;
          font-weight: 900;
        }
        .close {
          border: 0;
          background: transparent;
          padding: 0;
          color: #115930;
          font-size: 3.75vw;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          line-height: 1;
          &-icon {
            width: 5.9375vw;
            height: 5.9375vw;
            margin-bottom: 2.03125vw;
          }
        }
      }
      .field-group {
        display: flex;
        flex-direction: column;
        margin-top: 9.25vw;
        height: calc(100% - 21.09vw - 11.25vw);
        padding: 0 5.625vw;
        overflow-y: scroll;
        .field {
          margin-bottom: 10.3125vw;
          .label {
            font-size: 4.6875vw;
            color: #7f7f7e;
            font-weight: 700;
            margin-bottom: 9.21875vw;
          }
        }
      }
      .search {
        width: 100%;
        height: 17.97vw;
        background: #115930;
        color: white;
        font-size: 7.5vw;
        font-weight: 900;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        border: 0;
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 6;
        .count {
          font-weight: 400;
          position: absolute;
          top: 5.40625vw;
          left: 3.75vw;
        }
      }
    }
  script.
    import searchIconImage from 'tags/smartsearch/search-icon.png'
    import orangePlus from 'tags/smartsearch/orange-plus.png'
    import orangeMinus from 'tags/smartsearch/orange-minus.png'
    import closeIcon from 'tags/smartsearch/close-icon.png'

    export default {
      searchIconImage,
      orangePlus,
      orangeMinus,
      closeIcon,
      isMounted: false,
      didClickClose() {
        if (this.props.type !== 'in_modal') return

        window.scrollTo(0, document.querySelector(".smartsearch").dataset.scrollY);
        document.body.style.overflow = "auto";
        document.querySelector('.smartsearch.in_modal').classList.add('hidden')
        document.querySelector('.modal-background').remove()
      },
      onChangeKeyword(e) {
        this.update({
          keywordQuery: e.target.value
        })
      },
      onPressKey(e) {
        if ( e.which !== 13 || ( e.keyCode === 13 && (e.shiftKey === true || e.ctrlKey === true || e.altKey === true) )) {
          return false;
        }
        this.update({
          keywordQuery: e.target.value
        })
        this.submitSearch()
      },
      toggleField(key) {
        const showFieldFlags = this.state.showFieldFlags
        showFieldFlags[key] = !this.state.showFieldFlags[key]
        const isShown = showFieldFlags[key]
        const field = document.querySelector(`.sp .fields .field.${key}`)
        field.classList.toggle("closed", !isShown);
        this.update({ showFieldFlags })
        setTimeout(this.scrollWindow, 300)
      },
      initializeField() {
        this.state.showFieldFlags = {
          "keyword": this.getExistQuery('sa'),
          "price": this.getExistQuery('pr'),
          "material": this.getExistQuery('mt'),
          "strap": this.getExistQuery('st'),
          "color": this.getExistQuery('cl'),
          "case-width": this.getExistQuery('cw') || this.getExistQuery('cwr'),
          "gender": this.getExistQuery('gn'),
          "waterproofs": this.getExistQuery('wp') || this.getExistQuery('wpr'),
          "movement": this.getExistQuery('mv'),
          "functions": this.getExistQuery('fn')
        }
        const existQueryCount = Object.values(this.state.showFieldFlags).reduce((prev, crnt) => prev + (crnt === "" ? 0 : 1), 0)
        const hasCategoryQuery = this.getExistQuery('cid') !== "" || this.getExistQuery('gid') !== "" || this.getExistQuery('rid') !== ""
        this.state.shouldNoFollow = existQueryCount > (hasCategoryQuery ? 1 : 2)
      },
      fetchWatchesCount() {
        const queries = [
          ['cid', this.state.categoryQuery],
          ['gid', this.state.referenceGroupQuery],
          ['rid', this.state.referenceQuery],
          ['pr', this.state.priceRangeQuery],
          ['mt', this.state.materialQuery],
          ['st', this.state.strapQuery],
          ['cl', this.state.colorQuery],
          ['cw', this.state.caseWidthQuery],
          ['cwr', this.state.caseWidthRangeQuery],
          ['gn', this.state.genderQuery],
          ['wp', this.state.waterproofsQuery],
          ['wpr', this.state.waterproofsRangeQuery],
          ['mv', this.state.movementQuery],
          ['fn', this.state.functionQuery],
        ]
        this.props.loader.loadTotalCount(queries)
        this.update({
          isLoading: true
        })
        this.props.observable.trigger('onUpdateIsLoading', this.state.isLoading)
      },
      initializeByExistQuery() {
        const categoryQuery = this.state.categoryQuery || decodeURIComponent(this.getExistQuery('cid')) || this.getCategoryQuery()
        this.state.categoryQuery = categoryQuery
        this.state.referenceGroupQuery = this.state.referenceGroupQuery || decodeURIComponent(this.getExistQuery('gid')) || this.getGroupQuery()
        this.state.referenceQuery = this.state.referenceQuery || decodeURIComponent(this.getExistQuery('rid')) || this.getReferenceQuery()
        this.state.isMultiCategory = categoryQuery && (new String(categoryQuery)).includes(',')
        this.state.priceRangeQuery = decodeURIComponent(this.getExistQuery('pr'))
        this.state.materialQuery = decodeURIComponent(this.getExistQuery('mt'))
        this.state.strapQuery = decodeURIComponent(this.getExistQuery('st'))
        this.state.colorQuery = decodeURIComponent(this.getExistQuery('cl'))
        this.state.caseWidthQuery = decodeURIComponent(this.getExistQuery('cw'))
        this.state.caseWidthRangeQuery = decodeURIComponent(this.getExistQuery('cwr'))
        this.state.genderQuery = decodeURIComponent(this.getExistQuery('gn'))
        this.state.waterproofsQuery = decodeURIComponent(this.getExistQuery('wp'))
        this.state.waterproofsRangeQuery = decodeURIComponent(this.getExistQuery('wpr'))
        this.state.movementQuery = decodeURIComponent(this.getExistQuery('mv'))
        this.state.functionQuery = decodeURIComponent(this.getExistQuery('fn'))
        this.state.keywordQuery = decodeURIComponent(this.getExistQuery('sa'))
        if (this.state.keywordQuery) {
          this.state.keywordQuery = this.state.keywordQuery.replace('+', ' ')
        }
        const form = document.querySelector('#smart_search_form')
        if (!form) return

        this.state.formData = new FormData(form)
      },
      getExistQuery(key) {
        const result = (new RegExp('[?&]'+encodeURIComponent(key)+'=([^&]*)')).exec(location.search)
        return (!!result ? result[1] : '')
      },
      getReferenceQuery() {
        let brand, model, group;
        if (!this.state.selectedCategories) return ''

        if (this.state.selectedCategories.length == 1) brand = this.state.selectedCategories[0]
        else return ''

        if (!!brand.reference_group) group = brand.reference_group
        else if (!!brand.reference) return brand.reference.id

        if (!!group && !!group.reference) return group.reference.id

        if (brand.models && brand.models.length == 1) model = brand.models[0]
        else return ''

        if (!!model.reference_group) group = model.reference_group
        else if (!!model.reference) return model.reference.id
        else return ''

        return !!group.reference ? group.reference.id : ''
      },
      getGroupQuery() {
        let brand, model;
        if (!this.state.selectedCategories) return ''

        if (this.state.selectedCategories.length == 1) brand = this.state.selectedCategories[0]
        else return ''

        if (!!brand.reference_group) return brand.reference_group.id

        if (brand.models && brand.models.length == 1) model = brand.models[0]
        else return ''

        return !!model.reference_group ? model.reference_group.id : ''
      },
      getCategoryQuery() {
        const selectedCategories = this.state.selectedCategories
        if (!this.state.selectedCategories) return ''

        const brand = this.state.selectedCategories.length === 1 ? selectedCategories[0] : undefined
        if (!brand) return ''

        return brand.models && brand.models.length === 1 ? brand.models[0].id : brand.id
      },
      scrollWindow() {
        if (!document.querySelector('.in_sidebar .search-button-wrap')) return
        const currentScroll = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0
        const offsetTop = document.querySelector(".smartsearch").getBoundingClientRect().top + currentScroll
        const initialScrollTop = document.querySelector('.smartsearch .fields .price').getBoundingClientRect().top + currentScroll - offsetTop
        const searchButtonWrapHeight = document.querySelector('.in_sidebar .search-button-wrap').getBoundingClientRect().height
        const offsetBottom = 0
        const followLimit = document.querySelector('.smartsearch .fields .field.functions').getBoundingClientRect().top + currentScroll + document.querySelector('.smartsearch .fields .functions').getBoundingClientRect().height

        const innerHeight = window.innerHeight || document.documentElement.clientHeight || 0
        const isFixedToTop = currentScroll + innerHeight < initialScrollTop + offsetTop + searchButtonWrapHeight + offsetBottom
        const isFollowedToScroll = currentScroll + innerHeight < followLimit + searchButtonWrapHeight + offsetBottom
        const isNotFixed = this.props.mobile && this.state.isOpenedSelectCategoryWindow
        if (isFixedToTop && !isNotFixed) {
          document.querySelector('.in_sidebar .search-button-wrap').style.position = 'absolute'
          document.querySelector('.in_sidebar .search-button-wrap').style.bottom = 'auto'
          document.querySelector('.in_sidebar .search-button-wrap').style.top = initialScrollTop + 'px'
        } else if( isFollowedToScroll || isNotFixed) {
          document.querySelector('.in_sidebar .search-button-wrap').style.position = 'fixed'
          document.querySelector('.in_sidebar .search-button-wrap').style.bottom = offsetBottom + 'px'
          document.querySelector('.in_sidebar .search-button-wrap').style.top = 'auto'
        } else {
          document.querySelector('.in_sidebar .search-button-wrap').style.position = 'absolute'
          document.querySelector('.in_sidebar .search-button-wrap').style.bottom = 'auto'
          document.querySelector('.in_sidebar .search-button-wrap').style.top = followLimit - offsetTop + 20 + 'px'
        }
      },
      submitSearch() {
        const keywordField = document.querySelector('.keyword input')
        if (keywordField) {
          this.state.keywordQuery = document.querySelector('.keyword input').value
        }
        this.update()
        this.root.querySelector('.smartsearch form').submit()
      },
      onBeforeMount(props, state) {
        state.hasStock = !location.pathname.includes('/categories/') || props.count > 0
        state.selectedCategories = !!props.encodedCategories ? JSON.parse(props.encodedCategories) : undefined
        state.showFieldFlags = {
          "keyword": false,
          "price": false,
          "material": false,
          "strap": false,
          "color": false,
          "case-width": false,
          "gender": false,
          "waterproofs": false,
          "movement": false,
          "functions": false
        }
        state.isOpenedSelectCategoryWindow = false
        props.observable.on('onUpdateFunctionQuery', (query) => {
          state.functionQuery = query
          this.fetchWatchesCount()
        })
        props.observable.on(`onClickSubmitInCategoryWindow-${props.type}`, () => {
          this.submitSearch()
        })
        props.observable.on('onUpdateIsOpenedSelectCategoryWindow', (isOpened) => {
          state.isOpenedSelectCategoryWindow = isOpened
          this.scrollWindow()
        })
        props.loader.on(props.loader.handler(), (fetchedCount) => {
          state.isLoading = false
          props.observable.trigger('onUpdateIsLoading', state.isLoading)
          state.fetchedCount = fetchedCount.count
          props.observable.trigger('onUpdateFetchedCount', state.fetchedCount)
        })
        if (props.type === "in_sidebar") {
          window.addEventListener('scroll', () => {
            this.scrollWindow()
          })
        }
        this.initializeField()
        this.initializeByExistQuery()
      },
      onUpdateSelectedCategory(categoryQuery, referenceGroupQuery, referenceQuery) {
        this.state.categoryQuery = categoryQuery
        this.state.referenceGroupQuery = referenceGroupQuery
        this.state.referenceQuery = referenceQuery
        this.state.isMultiCategory = categoryQuery && categoryQuery.includes(',')
        if (this.isMounted) this.update()
      },
      onUpdatePriceRange(query) {
        this.state.priceRangeQuery = query
        this.fetchWatchesCount()
      },
      onUpdateMaterial(query) {
        this.state.materialQuery = query
        this.fetchWatchesCount()
      },
      onUpdateStrap(query) {
        this.state.strapQuery = query
        this.fetchWatchesCount()
      },
      onUpdateColor(query) {
        this.state.colorQuery = query
        this.fetchWatchesCount()
      },
      onUpdateCaseWidth(caseWidthQuery, caseWidthRangeQuery) {
        this.state.caseWidthQuery = caseWidthQuery
        this.state.caseWidthRangeQuery = caseWidthRangeQuery
        this.fetchWatchesCount()
      },
      onUpdateGender(query) {
        this.state.genderQuery = query
        this.fetchWatchesCount()
      },
      onUpdateWaterproofs(waterproofsQuery, waterproofsRangeQuery) {
        this.state.waterproofsQuery = waterproofsQuery
        this.state.waterproofsRangeQuery = waterproofsRangeQuery
        this.fetchWatchesCount()
      },
      onUpdateMovement(query) {
        this.state.movementQuery = query
        this.fetchWatchesCount()
      },
      onUpdateFunctions(query) {
        this.state.functionQuery = query
        this.fetchWatchesCount()
      },
      onMounted(props, state) {
        this.initializeField()
        this.initializeByExistQuery()
        this.update()
        this.fetchWatchesCount()
        this.isMounted = true
      }
    }
